var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layout-node",
      class: _vm.nodeClasses,
      style: _vm.style,
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.onClick($event)
        }
      }
    },
    [
      _c("span", { staticClass: "caption" }, [_vm._v(_vm._s(_vm.caption))]),
      _vm._v(" "),
      _vm.columns
        ? _c("span", { staticClass: "columns" }, [
            _c("i", { staticClass: "el-icon-s-grid" }),
            _vm._v(_vm._s(_vm.columns))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "child-nodes" },
        _vm._l(_vm.node.Children, function(child) {
          return _c("app-layout-node", {
            key: child.Name,
            attrs: {
              node: child,
              "active-node": _vm.activeNode,
              "active-tab": _vm.activeTab,
              "active-tab2nd": _vm.activeTab2nd
            },
            on: { "app-event": _vm.onAppEvent }
          })
        }),
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dad094f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dad094f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/parts/AppLayoutNode.vue
// module id = null
// module chunks = 